import * as yup from 'yup';

export const BookingValidator = yup.object({
  name: yup.string().required('invalidName'),
  email: yup.string().optional().email('invalidEmail'),
  phone: yup
    .string()
    .required('phoneIsRequired')
    .min(8, 'invalidPhone')
    .max(12, 'invalidPhone')
    .matches(/^[0-9]+$/, { message: 'invalidPhone' }),
  preferredDate: yup.string().optional(),
});

export const EmailValidator = yup.object({
  email: yup.string().required().email('invalidEmail'),
});
